'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var DynamicHeader = require('@narvar/nth-bundle-dynamic-header');
var NarvarFooter = require('@narvar/nth-bundle-narvar-footer');
var CsrSignInForm = require('../../components/CsrSignInForm/CsrSignInForm.js');
var CsrSignInWizard_module = require('./CsrSignInWizard.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var DynamicHeader__default = /*#__PURE__*/_interopDefaultLegacy(DynamicHeader);
var NarvarFooter__default = /*#__PURE__*/_interopDefaultLegacy(NarvarFooter);

const CsrSignInWizard = () => /*#__PURE__*/React__default["default"].createElement("div", {
  className: CsrSignInWizard_module["default"].pageWrapper
}, /*#__PURE__*/React__default["default"].createElement(DynamicHeader__default["default"], {
  featureName: "narvarHeader"
}), /*#__PURE__*/React__default["default"].createElement("div", {
  className: CsrSignInWizard_module["default"].desktopHeightWrapper
}, /*#__PURE__*/React__default["default"].createElement(CsrSignInForm["default"], null)), /*#__PURE__*/React__default["default"].createElement("div", {
  className: CsrSignInWizard_module["default"].footerPadding
}, /*#__PURE__*/React__default["default"].createElement(NarvarFooter__default["default"], {
  featureName: "narvarFooter"
})));

exports["default"] = CsrSignInWizard;
